<template>
  <div>
    <h3>Member management</h3>
    <v-btn class="btn" :loading="loading" :disabled="loading" depressed color="primary" @click.native="downloadPropertyManagers">
    Download property managers
    <v-icon right dark>save_alt</v-icon>
    </v-btn>
  </div>
</template>

<script>
import $ from 'jquery'
import httpService from '@/core/http-service'

export default {
  data: () => ({
    loading: false
  }),
  computed: {
    downloadUrl() {
      const params = $.param({ token: this.$store.getters.authenticationData.accessToken })
      return `${httpService.baseUrl}/api/v1/rpc/members/propertymanagers?${params}`
    }
  },
  methods: {
    downloadPropertyManagers() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 5000)
      window.location.href = this.downloadUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.btn { margin-left: 0; }
</style>
